export const defaultReservationTimeUnit = 30
